import { ITask, MutateTaskData } from '../task.types'

export const transformUpdateTaskFormValues = (
  selectedItemValues: Partial<ITask>,
) => {
  const {
    person,
    type,
    action,
    subject,
    assignedTo,
    activityDate,
    createdAt,
    updatedAt,
    priority,
    status,
    createdBy,
    updatedBy,
    id,
  } = selectedItemValues
  const transformedValues: MutateTaskData = {
    id,
    person,
    type,
    action,
    subject,
    priority,
    status,
    createdBy,
    updatedBy,
  }

  if (activityDate) {
    transformedValues.activityDate = new Date(activityDate)
  }
  if (createdAt) {
    transformedValues.createdAt = new Date(createdAt)
  }
  if (updatedAt) {
    transformedValues.updatedAt = new Date(updatedAt)
  }
  if (assignedTo) {
    transformedValues.assignedToId = assignedTo.id
  }

  return transformedValues
}
